export const environment = {
  production: true,
  apiBaseUrl: 'https://api.groupwisdom.tech/v1/',
  apiBaseUrlV2: 'https://api.groupwisdom.tech/v2/',
  frontendBaseUrlWithWww: 'https://groupwisdom.tech/',
  frontendBaseUrlWithoutWww: 'https://groupwisdom.tech/'
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts